import { Base } from '../base-component';
import './podcast-related-podcast-stack.component.scss';

import * as $ from 'jquery';

export class PodcastRelatedPodcastStack extends Base {

	constructor(element: Element){

		super(element);

	}

	containers: any;
	containersJs: any;
	buttons: any;
	scrollTO: any;
	clickedTarget: any;

	init(){

		this.containers = Array.from(this.element.querySelectorAll('.podcast-related-podcast-stack-item__type-feature'));
		this.buttons = Array.from(this.element.querySelectorAll('.podcast-related-podcast-stack-item'));

	}

	bindEvents() {

		this.buttons.map((item) => item.addEventListener('click', (event) => {

			let element;
			let clickedExternal;
			let clickedTarget = event.target;
			element = clickedTarget.closest('.podcast-related-podcast-stack-item');
			let clickedIndex = element.getAttribute('data-index'); 
			if(element.getAttribute('data-youtube-id')){
				clickedExternal = element.getAttribute('data-youtube-id');
			}

			this.hideActiveButtons();
			element.classList.add('active');

			this.hideContainers();
			this.containers.map((item) => {
				if(item.getAttribute('data-index') === clickedIndex) {
					item.classList.remove('d-none');
					if(document.querySelector('.header')) {
						if(document.querySelector('.header').classList.contains('header--sticky')) {
							$('html,body').animate({ 
								scrollTop: $(this.element).offset().top - 65
							}, 'slow');
						}else{
							$('html,body').animate({ 
								scrollTop: $(this.element).offset().top - 195
							}, 'slow');
						}
					}
					this.pauseOtherAudios(item);
				}
				
			});
			
		}));
	
	}

	hideActiveButtons() {
		this.buttons.map((item) => {
			item.classList.remove('active');
		});
	}

	hideContainers() {
		this.containers.map((item) => {
			item.classList.add('d-none');
		});
	}

	pauseOtherAudios(container: any) {
        if(container) {
			let dataIndex = container.getAttribute('data-index');
			this.containers.map(((containerChild)=>{
				let vidavee = Array.from(containerChild.querySelectorAll('audio'));
				vidavee.map((audio)=>{
                    audio.pause();
				});
			}));
		}
	}

}


// WEBPACK FOOTER //
// ./components/podcast-related-podcast-stack/podcast-related-podcast-stack.component.ts